import { ICON_PATHS } from "../lib/platforms";

// The remifo mark: three circles in a balanced cluster. It reads as several
// channels drawn from one source, and as presence, the core idea of being seen
// across every feed. Solid circles in currentColor so it adapts to any theme.
export function LogoMark({ size = 24, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
      aria-hidden="true"
    >
      <circle cx="12" cy="6.2" r="4.6" />
      <circle cx="6.6" cy="16" r="4.6" />
      <circle cx="17.4" cy="16" r="4.6" />
    </svg>
  );
}

export function Logo({ size = 30 }) {
  return (
    <div className="flex items-center gap-2.5 select-none">
      <div
        className="rounded-[10px] bg-accent text-accent-foreground flex items-center justify-center"
        style={{ width: size, height: size }}
      >
        <LogoMark size={size * 0.62} />
      </div>
      <span
        className="text-[19px] font-semibold tracking-tight text-foreground"
        style={{ letterSpacing: "-0.02em" }}
      >
        remifo
      </span>
    </div>
  );
}

// In the app chrome, platform glyphs render in the current text color so they
// stay visible in both themes (X and Threads are otherwise black on black).
export function PlatformIcon({ id, size = 18, className = "", style }) {
  const d = ICON_PATHS[id];
  if (!d) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}